<template>
  <section class="_pts _pb0">
    <div container>
      <form @submit.prevent="search" class="against-grey-bg _mbs">
        <div v-if="addingUsersToGroup">
          <h3 class="_mbs _mt0">
            Add Users to Group
          </h3>
          <div class="_mbs">
            <strong>Users to Add:</strong> {{ userListString }}
          </div>
        </div>
        <h4 class="_mbs _mt0">
          Group Search Context:
        </h4>
        <div grid="row wrap">
          <div column="6">
            <div class="form-group">
              <label for="subGroupName">Group Name:</label>
              <input
                type="text"
                id="groupName"
                name="groupName"
                value=""
                v-model.trim="name"
              />
            </div>
          </div>
          <div column="6">
            <div class="form-group">
              <label for="subGroupId">Group ID:</label>
              <input
                type="text"
                id="groupId"
                name="groupId"
                value=""
                v-model.trim="id"
              />
            </div>
          </div>
          <div column="6 +6" class="flex-wrap _mbxs" v-if="isInternalUser">
            <input
              id="isParentGroupSearch"
              type="checkbox"
              class="_mrxs _wauto"
              v-model="isParentGroupSearch"
            />
            <label for="isParentGroupSearch">Search Parent Groups</label>
          </div>
        </div>

        <div class="_text-center">
          <async-button
            type="submit"
            class="_mtxs --sm"
            :executing="submitting"
          >
            <template #buttonContent>
              <span>Search</span>
            </template>
          </async-button>
        </div>
      </form>
    </div>
    <collapsible-section :collapsible="false" :collapsed="false" class="_p0">
      <template #headerText>
        <p class="color-leaf">Results</p>
      </template>

      <template #collapsibleSection>
        <async-loader v-if="!loaded" />
        <no-results-message v-else-if="loaded && !searchResults" />
        <div container v-else>
          <advanced-table
            class="_p0"
            title="Group Search Results:"
            id="group-results"
            :headers="searchHeaders"
            :items="searchResults"
            :clickable="true"
          >
            <template #items="{ item, visibleHeaders, getCellValue }">
              <tr>
                <template v-for="(header, index) in visibleHeaders">
                  <td
                    v-if="header.value === 'groupSelect'"
                    :key="index"
                    @click.stop="groupCellClicked(item)"
                  >
                    <a href="javascript:void(0)">
                      Select
                    </a>
                  </td>
                  <td
                    v-else-if="header.value === 'groupName'"
                    :key="index"
                    @click.stop="groupCellClicked(item)"
                  >
                    <a href="javascript:void(0)">
                      {{ getCellValue(item, header) }}
                    </a>
                  </td>
                  <td
                    v-else-if="header.text === 'Group Details'"
                    :key="index"
                    @click="goToGroup(item)"
                  >
                    <a href="javascript:void(0)">
                      View Details
                    </a>
                  </td>
                  <td v-else @click="groupCellClicked(item)" :key="index">
                    {{ getCellValue(item, header) }}
                  </td>
                </template>
              </tr>
            </template>
          </advanced-table>
        </div>
      </template>
    </collapsible-section>
  </section>
</template>
<script>
import AdvancedTable from '@organisms/AdvancedTable.vue';
import AsyncButton from '@molecules/AsyncButton.vue';
import AsyncLoader from '@molecules/AsyncLoader.vue';
import RequestHelper from '@mixins/RequestHelper';
import SearchHelper from '@mixins/SearchHelper';
import auth from '@mixins/auth';
import SearchApi from '@api/SearchApi';
import formattable from '@mixins/formattable';
import { mapActions, mapGetters } from 'vuex';
import CollapsibleSection from '@sections/CollapsibleSection';

export default {
  mixins: [RequestHelper, SearchHelper, formattable, auth],
  components: {
    AdvancedTable,
    AsyncButton,
    AsyncLoader,
    CollapsibleSection
  },
  data() {
    return {
      id: '',
      name: '',
      searchHeaders: [
        { text: 'Group Name', align: 'left', value: 'groupName' },
        { text: 'Group ID', value: 'groupId' },
        { text: 'Group Details', value: 'groupDetails' },
        { text: 'Select', value: 'groupSelect' }
      ],
      groups: [],
      whiteListedQueryParams: ['name', 'id'],
      isParentGroupSearch: false
    };
  },
  computed: {
    ...mapGetters(['isInternalUser', 'subGroupAccess']),
    computedId() {
      return this.id || '';
    },
    computedName() {
      return this.name || '';
    },
    searchResults() {
      if (this.groups.status == 'NoRecordFound' || this.groups.length == 0) {
        return;
      }

      return this.groups;
    },
    query() {
      return {
        id: this.computedId,
        name: this.computedName,
        isParentGroupSearch: this.isParentGroupSearch
      };
    },
    users() {
      return this.$store.getters['users2/userIdsToBeAdded'] || [];
    },
    addingUsersToGroup() {
      return this.users.length > 0;
    },
    userListString() {
      return this.users.join(', ');
    }
  },
  methods: {
    ...mapActions('groupSelector', {
      groupClicked: 'SET_GROUP'
    }),
    groupCellClicked(group) {
      if (!this.addingUsersToGroup) {
        this.groupClicked(group);
      } else {
        this.$store.commit('users2/SET_GROUP_TO_ADD_USERS_TO', {
          id: group.groupId,
          name: group.groupName
        });
        this.$router.push({ name: 'add-users-to-group' });
      }
    },
    goToGroup(group) {
      this.$store.commit('groupSelector/SET_GROUP_DETAIL_ID', group.groupId);
      this.$router.push({
        name: 'group'
        // params: {
        //   groupId: group.groupId
        // }
      });
    },
    search() {
      if (!this.id && !this.name) {
        this.loaded = true;
        return;
      }

      if (this.isInternalUser) {
        this.internalUserGroupSearch();
      } else {
        this.externalUserGroupSearch();
      }
    },

    internalUserGroupSearch() {
      this.bindVueDataToRequestResponse({
        vueDatum: 'groups',
        responseChildFieldName: 'groups',
        requestMethod: new SearchApi().searchGroups,
        // requestMethod: new SearchApi({ simulateExample: 'Group Search - Group Id Search'}).searchGroups,
        query: this.query
      });
    },

    externalUserGroupSearch() {
      let results = [];
      let groupCksAccountedFor = [];
      if (this.subGroupAccess) {
        this.subGroupAccess.forEach(subGroup => {
          let partialIdMatch =
            subGroup.groupId
              .toLowerCase()
              .indexOf(this.computedId.toLowerCase()) > -1;
          let partialNameMatch =
            subGroup.groupName
              .toLowerCase()
              .indexOf(this.computedName.toLowerCase()) > -1;

          // this is ugly and dumb but basically make sure that we're not adding duplicates because of
          // how they've decided to structure their subGroupAccess JSON payload.
          // Before this was returning duplicate results.
          if (
            partialNameMatch &&
            partialIdMatch &&
            !groupCksAccountedFor.includes(subGroup.groupCk)
          ) {
            groupCksAccountedFor.push(subGroup.groupCk);
            results.push(subGroup);
          }
        });
      }
      this.groups = results;
      this.loaded = true;
    }
  },
  destroyed() {
    this.$store.commit('CLEAR_QUERY_PARAMS');
  }
};
</script>
<style scoped lang="scss">
.flex-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
